module.exports = __webpack_public_path__ + "static/media/Plane_taking_off.ac97c91d.mp3";